<p-toast></p-toast>
<div class="p-3 unit-listing-container">
  <div class="page-title d-flex justify-content-between align-items-center">
    <div>
      <h3>Unit Listing</h3>
    </div>
    <div>
      <p-button type="button" icon="pi pi-sync" [style.margin-right]="'0.3rem'" class="primary-btn p-button-secondary"
        (click)="resetFilters()"></p-button>
      <p-button pButton class="primary-btn" label="Create Unit" (click)="openCreateSidebar()"><i
          class="pi pi-plus"></i></p-button>
    </div>
  </div>

  <div class="filters mb-3">
    <div class="filters-container w-100 m-0">
      <div class="p-1">
        <label for="search" class="dropdown-label">Search</label>
        <input type="text" placeholder="Search..." class="form-control" [(ngModel)]="filters.search"
        (input)="onFilterChange(); sanitizeInput($event)" (keydown)="blockSpecialChars($event)"
        (paste)="blockSpecialCharsOnPaste($event)" (drop)="blockSpecialCharsOnDrop($event)">
      </div>
      <div class="p-1">
        <label for="planName" class="dropdown-label">Floorplan Name</label>
        <p-dropdown [options]="allFloorplanNames" [(ngModel)]="filters.floorplan" placeholder="Select Floorplan Name"
          (onChange)="onFilterChange()" filter="true" [showClear]="true">
        </p-dropdown>
      </div>
      <div class="p-1">
        <label for="planName" class="dropdown-label">Select Beds</label>
        <p-dropdown [options]="allBedOptions" [(ngModel)]="filters.beds" placeholder="Select Beds"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div>
      <div class="p-1">
        <label for="planName" class="dropdown-label">Select Baths</label>
        <p-dropdown [options]="allBathOptions" [(ngModel)]="filters.baths" placeholder="Select Baths"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div>
      <div class="p-1">
        <label for="planName" class="dropdown-label">Select Square feet</label>
        <p-dropdown [options]="allSqftOptions" [(ngModel)]="filters.sq_ft" placeholder="Select Square feet"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div>
      <div class="p-1">
          <div class="d-flex flex-column gap-1">
              <label for="visibility_date" class="dropdown-label">Visibility Date</label>
              <p-calendar [(ngModel)]="filters.visibility_date" selectionMode="range" dateFormat="mm/dd/yy"
                  selectionMode="range" appendTo="body" placeholder="Select Date Range" [showIcon]="true" 
                  [numberOfMonths]="2" [showClear]="true" (ngModel)="filters.visibility_date"
                  (onSelect)="onFilterChange()" 
                  (onClear)="onFilterChange()"
                  (ngModelChange)="onFilterChange()">
              </p-calendar>
          </div>
      </div>
      <div class="p-1">
        <label for="planName" class="dropdown-label">Unit Availability</label>
        <p-dropdown [options]="waitlistOptions" [(ngModel)]="filters.waitlist" placeholder="All Units"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div>
    </div>

    <div class="unit-listing p-4 m-1 mt-3">
      <p-table [value]="units" [lazy]="true" [paginator]="true" [rows]="10" [totalRecords]="totalRecords"
        [responsiveLayout]="'scroll'" [sortField]="sorting.field" [sortOrder]="sorting.order"
        (onLazyLoad)="getAllUnits($event)"
        [rowsPerPageOptions]="[10,20,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th>
              <p-checkbox [(ngModel)]="selectAll" binary="true" (onChange)="toggleSelectAll()"></p-checkbox>
            </th>
            <th pSortableColumn="unit">Unit Name <p-sortIcon field="unit"></p-sortIcon></th>
            <th pSortableColumn="beds">Beds <p-sortIcon field="beds"></p-sortIcon></th>
            <th pSortableColumn="baths">Baths <p-sortIcon field="baths"></p-sortIcon></th>
            <th pSortableColumn="unit_occupant">Unit Occupant</th>
            <th pSortableColumn="min_price">Min Price <p-sortIcon field="min_price"></p-sortIcon></th>
            <th pSortableColumn="max_price">Max Price <p-sortIcon field="max_price"></p-sortIcon></th>
            <th pSortableColumn="availablity_date">Availability<p-sortIcon field="availablity_date"></p-sortIcon></th>
            <th pSortableColumn="visibility_date">Visibility<p-sortIcon field="availablity_date"></p-sortIcon></th>
            <th pSortableColumn="sq_ft">Square Feet <p-sortIcon field="sq_ft"></p-sortIcon></th>
            <th>Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-unit>
          <tr>
            <td>
              <p-checkbox [(ngModel)]="unit.isSelected" binary="true" (onChange)="onRowSelect()"></p-checkbox>
            </td>
            <td>
              {{ unit.unit }}
              <span *ngIf="unit.waitlist" class="badge bg-warning text-dark"
              (click)="onWaitlistClick(unit)" style="cursor:pointer">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M8.885 12.308h6.23q.213 0 .357-.144t.144-.357t-.144-.356t-.356-.143H8.885q-.213 0-.357.144q-.143.144-.143.356q0 .213.143.357t.357.143m0 2.769h6.23q.213 0 .357-.144t.144-.357t-.144-.356t-.356-.143H8.885q-.213 0-.357.144q-.143.144-.143.357t.143.356t.357.143m0 2.77h3.23q.213 0 .357-.145t.144-.356t-.144-.356t-.356-.144H8.885q-.213 0-.357.144q-.143.144-.143.357t.143.356t.357.143M6.615 21q-.69 0-1.152-.462T5 19.385V4.615q0-.69.463-1.152T6.616 3h7.213q.331 0 .632.13t.518.349L18.52 7.02q.217.218.348.518t.131.632v11.214q0 .69-.463 1.153T17.385 21zM14 7.2q0 .34.23.57t.57.23H18l-4-4z"/>
                </svg>
              </span>
            </td>
            <td>{{ unit.beds }}</td>
            <td>{{ unit.baths }}</td>
            <td>{{ unit?.tenant?.first_name }} {{ unit?.tenant?.last_name }}</td>
            <td>{{ unit.min_price | currency }}</td>
            <td>{{ unit.max_price | currency }}</td>
            <!-- <td [ngClass]="{'statusActive': unit.availablity_date <= today, 'statusPending': unit.availablity_date > today}">
              <span class=""> {{ unit.availablity_date <= today ? 'Available Now' : ('Available After: ' + (unit.availablity_date | date:'MM/dd/yy')) }} </span>
            </td> -->
            <td [ngClass]="getAvailabilityClass(unit)">
                <span *ngIf="unit.availability_status === AvailabilityStatus.NOTAVAILABLE">
                  {{AvailabilityStatusText.NOTAVAILABLE}}
                </span>
                <span *ngIf="unit.availability_status === AvailabilityStatus.AVAILABLENOW">
                  {{AvailabilityStatusText.AVAILABLENOW}}
                </span>
                <span *ngIf="unit.availability_status === AvailabilityStatus.DATE">
                  <ng-container *ngIf="unit.availablity_date && unit.availablity_date <= today; else availableAfter">
                    {{ AvailabilityStatusText.AVAILABLENOW }}
                  </ng-container>
                  <ng-template #availableAfter>
                    {{ unit.availablity_date ? 'Available After: ' + (unit.availablity_date | date:'MM/dd/yy') : "No Date Selected" }}
                  </ng-template>
                </span>
            </td>
            <!-- <td>
              {{ unit.visibility_date | date:'MM/dd/yy' }}
            </td> -->
            <td [ngClass]="{
                  'statusCancelled': unit.visibility_status === VisibilityStatus.NOTVISIBLE
                }">
              <span *ngIf="unit.visibility_status === VisibilityStatus.VISIBLENOW">{{VisibilityStatusText.VISIBLENOW}}</span>
              <span *ngIf="unit.visibility_status === VisibilityStatus.NOTVISIBLE">{{VisibilityStatusText.NOTVISIBLE}}</span>
              <span *ngIf="unit.visibility_status === VisibilityStatus.DATE || unit.visibility_date">
                {{ unit.visibility_date | date:'MM/dd/yy' }}
              </span>
            </td>
            <td>{{ unit.sq_ft }}</td>
            <td>
              <div class="d-flex align-items-center gap-2">
              <p-button pButton class="icon-secondary-btn p-mr-2" icon="pi pi-pencil"
                (click)="editUnit(unit)">
              </p-button>
              <p-button pButton class="icon-primary-btn" icon="pi pi-trash" (click)="confirmDelete(unit)">
              </p-button>
            </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="!units || units.length === 0" class="alert alert-info" role="alert">
      No Units available.
    </div>

    <div class="dlt-confirmation-dialog">
      <p-dialog header="Confirm Delete" [(visible)]="display" [modal]="true" [closable]="false">
        <small><i class="pi pi-exclamation-triangle text-danger"></i> Are you sure you want to delete this unit?</small>
        <p-footer>
          <p-button type="button" class="secondary-btn" [style.margin-right]="'0.3rem'"  pbutton label="No" icon="pi pi-times" (click)="onCancel()"></p-button>
          <p-button type="button" class="primary-btn" pbutton label="Yes" icon="pi pi-check" (click)="onConfirm()"></p-button>
        </p-footer>
      </p-dialog>
    </div>

    <p-dialog  [header]="type === 'edit' ? 'Update Unit' : 'Create Unit'"  [(visible)]="isSidebarVisible" [modal]="true" [position]="'right'"
      [style]="{ width: '35%' }" draggable="false">
      <app-units-form *ngIf="isSidebarVisible" [unit]="selectedUnit" (save)="onFormSubmit($event)"
      (mediaOpened)="openMediaLightbox($event.mediaList, $event.index)">
      </app-units-form>
    </p-dialog>

    <!-- Availability Dialog -->
     <div class="dlt-confirmation-dialog">
      <p-dialog header="Change Availability" [(visible)]="availabilityDialogVisible" [modal]="true" [closable]="true" [responsive]="true"
        [style]="{width: '100%',maxWidth:'500px'}" draggable="false">
          <div class="p-fluid">
            <div class="row">
              <div class="col-12">
                <div class="mb-2">
                  <label>Availability</label>
                  <select class="form-control"
                          [(ngModel)]="bulk.availability_status"
                          name="availability_status"
                          (change)="onAvailabilityChange($event)">
                    <option value="{{AvailabilityStatus.DATE}}">{{AvailabilityStatusText.DATE}}</option>
                    <option value="{{AvailabilityStatus.AVAILABLENOW}}">{{AvailabilityStatusText.AVAILABLENOW}}</option>
                    <option value="{{AvailabilityStatus.NOTAVAILABLE}}">{{AvailabilityStatusText.NOTAVAILABLE}}</option>
                  </select>
                </div>
              </div>
              <div class="col-12">
                <label>Availablity Date</label>
                <p-calendar id="availablity_date" [(ngModel)]="bulk.availablity_date" name="availabilityFrom"
                  [iconDisplay]="'input'" [showIcon]="true" dateFormat="mm/dd/yy" [disabled]="availabilityDisabled" 
                  (onSelect)="updateVisibilityMinDate()" [minDate]="minDate"required appendTo="body"></p-calendar>
              </div>
            </div>
          </div>
          <p-footer>
            <div class="d-flex align-items-center justify-content-end gap-2">
              <p-button label="Cancel" class="secondary-btn" (click)="availabilityDialogVisible = false"></p-button>
              <p-button label="Apply" class="primary-btn" (click)="applyBulkUpdate('availability')"></p-button>
            </div>
          </p-footer>
        </p-dialog>
     </div>

    <!-- Visibility Dialog -->
     <div class="dlt-confirmation-dialog">
       <p-dialog header="Change Visibility" [(visible)]="visibilityDialogVisible" [modal]="true" [closable]="true" [responsive]="true"
       [style]="{width: '100%',maxWidth:'500px'}" draggable="false">
       <div class="row">
        <div class="col-12">
          <div class="mb-2">
            <label>Visibility</label>
            <select class="form-control"
                    [(ngModel)]="bulk.visibility_status"
                    name="visibility_status"
                    (change)="onVisibilityChange($event)">
              <option value="{{VisibilityStatus.DATE}}">{{VisibilityStatusText.DATE}}</option>
              <option value="{{VisibilityStatus.VISIBLENOW}}">{{VisibilityStatusText.VISIBLENOW}}</option>
              <option value="{{VisibilityStatus.NOTVISIBLE}}">{{VisibilityStatusText.NOTVISIBLE}}</option>
            </select>
          </div>
        </div>
        <div class="col-12">
          <label>Visibility Date</label>
          <p-calendar id="visibility_date" [(ngModel)]="bulk.visibility_date" name="visibility_date"
          [iconDisplay]="'input'" [showIcon]="true" dateFormat="mm/dd/yy" [disabled]="visibilityDisabled" appendTo="body"></p-calendar>
        </div>
       </div>
         <p-footer>
           <div class="d-flex align-items-center justify-content-end gap-2">
             <p-button label="Cancel" class="secondary-btn" (click)="visibilityDialogVisible = false"></p-button>
             <p-button label="Apply" class="primary-btn" (click)="applyBulkUpdate('visibility')"></p-button>
           </div>
         </p-footer>
       </p-dialog>
     </div>

     <!-- Sidebar dialog for waitlist users -->
    <p-dialog
      header="Waitlist Users"
      [(visible)]="isWaitListSidebarVisible"
      [modal]="true"
      [position]="'right'"
      [style]="{ width: '35%' }"
      draggable="false"
      (onHide)="closeSidebar()"
    >
      <ng-container *ngIf="waitlistUsers.length > 0; else noUsers">
        <ul class="waitlisting">
          <li *ngFor="let user of waitlistUsers">
            <ng-template *ngIf="user.name">{{ user.name }} - </ng-template>
            {{ user.email }}
            <span *ngIf="user.phone"> - {{ user.phone }}</span>
            <span *ngIf="user.source"> - {{ user.source }}</span>
          </li>
        </ul>
      </ng-container>

      <ng-template #noUsers>
        <p>No users on waitlist for this unit.</p>
      </ng-template>
    </p-dialog>

  </div>
  <div class="bulk-action-buttons-container mb-3" *ngIf="selectedUnits.length > 0">
    <div class="bulk-action-buttons">
      <p class="m-0">{{ selectedUnits.length }} unit{{ selectedUnits.length === 1 ? '' : 's' }} selected</p>
      <div class="d-flex gap-2">
        <p-button label="Change Availability" icon="pi pi-calendar" class="primary-btn"
                  (click)="openAvailabilityDialog()"></p-button>
        <p-button label="Change Visibility" icon="pi pi-eye" class="primary-btn"
                  (click)="openVisibilityDialog()"></p-button>
      </div>
    </div>
  </div>
</div>

<p-galleria
  [(visible)]="showGalleria"
  [value]="mediaFiles"
  [(activeIndex)]="activeIndex"
  [showItemNavigators]="true"
  [showThumbnails]="false"
  [showIndicators]="false"
  [circular]="true"
  [fullScreen]="true"
  [autoPlay]="false"
  [containerStyle]="{ 'max-width': '900px' }"
  styleClass="custom-galleria-lightbox"
  (visibleChange)="onVisibleChange($event)">
  <ng-template pTemplate="item" let-media>
      <div class="lb-media-wrapper">
        <ng-container *ngIf="media.type === 'image'">
          <img [src]="media.url" class="lb-main-image"/>
        </ng-container>
        <ng-container *ngIf="media.type === 'video'">
          <video [src]="media.url" controls class="lb-main-video"></video>
        </ng-container>
      </div>
    </ng-template>
</p-galleria>
